export const MODAL_WIDTH = {
  xl: '90%',
  lg: '70%',
  md: '50%',
  sm: '30%',
};
